"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalContext = void 0;
var react_1 = __importDefault(require("react"));
var PortalManager_1 = require("./PortalManager");
exports.PortalContext = react_1.default.createContext(new PortalManager_1.PortalManager([], function (setter) { }));
//# sourceMappingURL=PortalContext.js.map